webpackJsonp([108],{

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus__ = __webpack_require__(65);




function interceptor(request, next) {
	var _this = this;

	var userToken = __WEBPACK_IMPORTED_MODULE_0__shared_helper__["a" /* default */].methods.getToken();
	if (this.$route.name !== 'login') {
		var urlRequest = request.url;
		if (!urlRequest.includes("//perudatos.controlinn.com/api")) {
			if (urlRequest.includes('//products.japisale.com') || urlRequest.includes('//sales.japisale.com')) {
				if (!request.headers.get('authorization')) {
					request.headers.set('Authorization', 'Bearer ' + '$2y$10$SRfH6cjRbqlxfgKPvWD1SOaVyK5u4boKeQi/rlbKKvbmTwxD1/sD6');
				}
			} else {
				request.headers.set('Authorization', 'Bearer ' + userToken);
			}
		}
	}
	__WEBPACK_IMPORTED_MODULE_2__bus__["a" /* default */].$emit('show-progress', true);
	return next(function (response) {
		__WEBPACK_IMPORTED_MODULE_2__bus__["a" /* default */].$emit('show-progress', false);
		var status = response.status;
		var loginRoute = { name: 'login' };
		if (status === 401) {
			_this.showNotification('Su sesión expiró.', 'error');
			_this.$router.push(loginRoute);
		} else if (status === 403) {
			_this.showNotification('No tiene suficientes permisos para realizar ésta acción', 'error');
		} else if (status === 500) {
			_this.showNotification('Ocurrió un error interno en el servidor.', 'error');
		}
	});
}

/* harmony default export */ __webpack_exports__["a"] = ({
	interceptor: interceptor,
	mixins: __WEBPACK_IMPORTED_MODULE_1__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__housekeeping_Dashboard__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__housekeeping_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__housekeeping_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__housekeeping_DashboardSales__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__housekeeping_DashboardSales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__housekeeping_DashboardSales__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__housekeeping_Housemaids__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__housekeeping_Housemaids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__housekeeping_Housemaids__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clerkinn_Laundry__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clerkinn_Laundry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__clerkinn_Laundry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__clerkinn_Minibar__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__clerkinn_Minibar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__clerkinn_Minibar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__housekeeping_Planning__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__housekeeping_Planning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__housekeeping_Planning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__housekeeping_ProblemReport__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__housekeeping_ProblemReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__housekeeping_ProblemReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__housekeeping_Maintenance__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__housekeeping_Maintenance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__housekeeping_Maintenance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__clerkinn_Products__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__clerkinn_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__clerkinn_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__housekeeping_Rooms__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__housekeeping_Rooms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__housekeeping_Rooms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__housekeeping_OtherEnviroments__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__housekeeping_OtherEnviroments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__housekeeping_OtherEnviroments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__housekeeping_Settings__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__housekeeping_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__housekeeping_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__housekeeping_States__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__housekeeping_States___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__housekeeping_States__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__clerkinn_Transfers__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__clerkinn_Transfers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__clerkinn_Transfers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__housekeeping_Users__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__housekeeping_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__housekeeping_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_NotFound__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__clerkinn_Guest__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__clerkinn_Guest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__clerkinn_Guest__);






















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		children: [{
			components: {
				default: __WEBPACK_IMPORTED_MODULE_4__housekeeping_Dashboard___default.a
			},
			name: 'dashboard',
			path: '/dashboard-housekeeping',
			meta: {
				breadcrumb: 'Dashboard'
			},
			redirect: '/dashboard/main',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 850));
				},
				name: 'main-dashboard',
				path: 'main'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 851));
				},
				name: 'detail-by-state',
				path: 'state/:stateId/:stateName',
				meta: {
					breadcrumb: 'State'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 852));
				},
				name: 'housemaids-by-state',
				path: 'housemaids-by-state/:stateId/:stateName',
				meta: {
					breadcrumb: 'Housemaids by state'
				},
				props: true
			}, {
				component: __WEBPACK_IMPORTED_MODULE_11__housekeeping_Maintenance___default.a,
				name: 'maintenance-container',
				path: '/maintenance',
				meta: {
					breadcrumb: 'Maintenance'
				},
				redirect: '/maintenance/unresolved',
				children: [{
					component: function component() {
						return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 857));
					},
					name: 'unresolved-maintenance',
					path: 'unresolved'
				}, {
					component: function component() {
						return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 856));
					},
					name: 'solved-maintenance',
					path: 'solved'
				}]
			}]
		}, {
			component: __WEBPACK_IMPORTED_MODULE_5__housekeeping_DashboardSales___default.a,
			name: 'dashboard-sales',
			path: '/dashboard/sales',
			meta: {
				breadcrumb: 'Sales'
			}
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_6__housekeeping_Housemaids___default.a
			},
			name: 'housemaids',
			path: '/housemaids',
			meta: {
				breadcrumb: 'Housemaids'
			},
			redirect: '/housemaids/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 855));
				},
				meta: {
					breadcrumb: 'Perfil Mucama'
				},
				name: 'housemaids-profile',
				path: ':id/profile',
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 854));
				},
				name: 'housemaids-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 310));
				},
				name: 'housemaids-new',
				path: 'new',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, 310));
				},
				name: 'housemaids-config',
				path: ':housemaidId/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 853));
				},
				name: 'housemaids-assign',
				path: 'asignar',
				meta: {
					breadcrumb: 'Asignar'
				}
			}]
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_13__housekeeping_Rooms___default.a
			},
			name: 'rooms',
			path: '/rooms',
			meta: {
				breadcrumb: 'Habitaciones',
				tab: 'Rooms'
			},
			redirect: '/rooms/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 858));
				},
				name: 'room-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 859));
				},
				name: 'room-detail',
				path: ':roomId',
				meta: {
					breadcrumb: 'Room'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 860));
				},
				name: 'room-photos',
				meta: {
					breadcrumb: 'Fotos'
				},
				path: ':roomId-:roomNumber/photos/:maidId/maid',
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 311));
				},
				name: 'create-room',
				path: 'new/create',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 311));
				},
				name: 'edit-room',
				path: ':id/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}]
		}, {
			component: __WEBPACK_IMPORTED_MODULE_14__housekeeping_OtherEnviroments___default.a,
			name: 'other-enviroments',
			path: '/other-enviroments',
			meta: {
				breadcrumb: 'Other enviroments',
				tab: 'Other enviroments'
			}
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_12__clerkinn_Products___default.a
			},
			name: 'products',
			path: '/products',
			meta: {
				breadcrumb: 'Products'
			},
			redirect: '/products/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 823));
				},
				name: 'product-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 307));
				},
				name: 'create-product',
				path: 'new',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 307));
				},
				name: 'config-product',
				path: ':productId/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}]
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_7__clerkinn_Laundry___default.a
			},
			name: 'laundry',
			path: '/laundry',
			meta: {
				breadcrumb: 'Laundry'
			},
			redirect: '/laundry/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 818));
				},
				name: 'laundry-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 304));
				},
				name: 'form-laundry',
				path: 'new',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 304));
				},
				name: 'config-laundry',
				path: ':laundryId/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 776));
			},
			name: 'billing',
			path: '/billing',
			meta: {
				breadcrumb: 'Billing'
			},
			redirect: 'billing/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 794));
				},
				name: 'list',
				path: 'list'
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 847));
			},
			name: 'lostandfound',
			path: '/lost-&-found',
			meta: {
				breadcrumb: 'Lost & Found'
			},
			redirect: '/lost-&-found/lost',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 846));
				},
				name: 'lost',
				path: 'lost'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 845));
				},
				name: 'found',
				path: 'found'
			}]
		}, {
			component: __WEBPACK_IMPORTED_MODULE_10__housekeeping_ProblemReport___default.a,
			name: 'problem-report',
			path: '/problem-report',
			meta: {
				breadcrumb: 'Problem report'
			},
			redirect: '/problem-report/unresolved',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 849));
				},
				name: 'unresolved',
				path: 'unresolved'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 848));
				},
				name: 'solved',
				path: 'solved'
			}]
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_18__housekeeping_Users___default.a
			},
			name: 'users',
			path: '/users',
			meta: {
				breadcrumb: 'Users'
			},
			redirect: '/users/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 863));
				},
				name: 'users-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 314));
				},
				name: 'users-new',
				path: 'new',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 314));
				},
				name: 'users-config',
				path: ':userId/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}]
		}, {
			component: __WEBPACK_IMPORTED_MODULE_9__housekeeping_Planning___default.a,
			name: 'planning-housekeeping',
			path: '/planning-housekeeping',
			meta: {
				breadcrumb: 'Planning'
			}
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_15__housekeeping_Settings___default.a
			},
			name: 'settings',
			path: '/type-cleaning',
			meta: {
				breadcrumb: 'Type cleaning'
			},
			redirect: '/type-cleaning/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 861));
				},
				name: 'settings-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 312));
				},
				name: 'settings-new',
				path: 'new',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 312));
				},
				name: 'settings-config',
				path: ':settingId/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}]
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_16__housekeeping_States___default.a
			},
			name: 'states',
			path: '/states',
			meta: {
				breadcrumb: 'States'
			},
			redirect: '/states/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 862));
				},
				name: 'states-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 313));
				},
				name: 'states-new',
				path: 'new',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 313));
				},
				name: 'states-config',
				path: ':stateId/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 841));
			},
			name: 'docs',
			path: '/docs',
			meta: {
				breadcrumb: 'Documentation'
			}
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_8__clerkinn_Minibar___default.a
			},
			name: 'minibar',
			path: '/minibar',
			meta: {
				breadcrumb: 'Minibar'
			},
			redirect: '/minibar/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 305));
				},
				name: 'minibar-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 93));
				},
				name: 'minibar-new',
				path: 'new',
				meta: {
					breadcrumb: 'New'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 93));
				},
				name: 'minibar-config',
				path: ':minibarId/edit',
				meta: {
					breadcrumb: 'Edit'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 306));
				},
				name: 'minibar-products',
				path: ':id/:name/products',
				meta: {
					breadcrumb: 'Products'
				},
				props: true
			}]
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_8__clerkinn_Minibar___default.a
			},
			name: 'warehouses',
			path: '/warehouses',
			meta: {
				breadcrumb: 'Warehouse'
			},
			redirect: '/warehouses/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 305));
				},
				name: 'warehouses-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 93));
				},
				name: 'warehouses-new',
				path: 'new',
				meta: {
					breadcrumb: 'Nuevo'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 93));
				},
				name: 'warehouses-config',
				path: ':minibarId/edit',
				meta: {
					breadcrumb: 'Editar'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(15/* duplicate */).then(__webpack_require__.bind(null, 306));
				},
				name: 'warehouses-products',
				path: ':id/:name/products',
				meta: {
					breadcrumb: 'Productos'
				},
				props: true
			}]
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_20__clerkinn_Guest___default.a
			},
			name: 'guest',
			path: '/guest',
			meta: {
				breadcrumb: 'Huésped'
			},
			redirect: '/guest/list-guest',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 303));
				},
				name: 'new-guest',
				path: 'new-guest',
				menta: {
					breadcrumb: 'Nuevo Huésped'
				},
				props: true
			}, {
				name: 'edit-guest',
				path: ':id/edit-guest',
				meta: {
					breadcrumb: 'Editar Huesped'
				},
				props: true,
				component: function component() {
					return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 303));
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 816));
				},
				name: 'list-guest',
				path: 'list-guest',
				meta: {
					breadcrumb: 'Lista de Huéspedes'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 815));
				},
				name: 'history-guest',
				path: 'history-guest',
				meta: {
					breadcrumb: 'Historial del Huesped'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 814));
				},
				name: 'detail-guest',
				path: 'detail-guest',
				meta: {
					breadcrumb: 'Detalle de Huesped'
				}
			}]
		}, {
			components: {
				default: __WEBPACK_IMPORTED_MODULE_17__clerkinn_Transfers___default.a
			},
			name: 'transfers',
			path: '/transfers',
			meta: {
				breadcrumb: 'Transfers'
			},
			redirect: '/transfers/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 836));
				},
				name: 'transfer-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 789));
			},
			name: 'reports',
			path: '/reports',
			meta: {
				breadcrumb: 'Reportes'
			},
			redirect: '/reports/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 830));
				},
				meta: {
					breadcrumb: 'Restaurante'
				},
				name: 'restaurant',
				path: 'restaurant'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 826));
				},
				meta: {
					breadcrumb: 'Cocina'
				},
				name: 'kitchen',
				path: 'kitchen'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 828));
				},
				meta: {
					breadcrumb: 'Ocupación Nueva'
				},
				name: 'occupancy-new',
				path: 'occupancy-new'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 827));
				},
				name: 'reports-list',
				path: 'list'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 829));
				},
				meta: {
					breadcrumb: 'Ocupación'
				},
				name: 'report-occupancy',
				path: 'occupancy'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 825));
				},
				meta: {
					breadcrumb: 'Empresa'
				},
				name: 'report-company',
				path: 'company'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 824));
				},
				meta: {
					breadcrumb: 'Reservas'
				},
				name: 'report-bookings',
				path: 'bookings'
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 786));
			},
			name: 'kardex',
			path: 'products/:productId/:productName/:warehouseId?/kardex',
			meta: {
				breadcrumb: 'Kardex'
			},
			props: true
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 843));
				}
			},
			name: 'configuration',
			path: '/configuration',
			meta: {
				breadcrumb: 'Configuration'
			},
			redirect: '/configuration/company',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 842));
				},
				name: 'company',
				path: 'company',
				meta: {
					breadcrumb: 'Company'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 844));
				},
				name: 'subsidiaries',
				path: 'subsidiaries',
				meta: {
					breadcrumb: 'Subsidiaries'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 783));
				}
			},
			name: 'customers',
			path: '/customers',
			redirect: '/customers/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 812));
				},
				name: 'customers-list',
				path: 'list',
				meta: {
					breadcrumb: 'Clientes'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 302));
				},
				name: 'config-customer',
				path: 'edit',
				meta: {
					breadcrumb: 'Edit'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 302));
				},
				name: 'new-customer',
				path: 'new',
				meta: {
					breadcrumb: 'Nuevo Cliente'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 779));
				}
			},
			name: 'calendar',
			path: '/calendar',
			meta: {
				breadcrumb: 'Calendar'
			},
			redirect: '/calendar/:bookingCode?',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 800));
				},
				name: 'cms-calendar',
				path: ':bookingCode?',
				props: true
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 785));
				}
			},
			name: 'housekeeping',
			path: '/housekeeping',
			meta: {
				breadcrumb: 'Housekeeping'
			},
			redirect: '/housekeeping/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 817));
				},
				name: 'housekeeping-list',
				path: 'list',
				meta: {
					breadcrumb: 'List'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 775));
				}
			},
			name: 'alarm',
			path: '/alarm',
			meta: {
				breadcrumb: 'Alarm'
			},
			redirect: '/alarm/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 793));
				},
				name: 'alarm-list',
				path: 'list',
				meta: {
					breadcrumb: 'Crear alarma'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 782));
				}
			},
			name: 'check-in',
			path: 'check-in',
			meta: {
				breadcrumb: 'Check In'
			},
			redirect: '/check-in/new-form',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 806));
				},
				name: 'check-in-form',
				path: 'form/:bookingCode?/:hotelId?',
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 807));
				},
				name: 'checkin-form-tabs',
				path: 'new-form/:hotelId/:roomTypeId/:customerId?',
				props: true
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 819));
			},
			name: 'multi-rooms-reservation',
			path: 'multi-rooms-reservation',
			meta: {
				breadcrumb: 'Reservas'
			},
			redirect: '/multi-rooms-reservation/select-rooms',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 820));
				},
				name: 'select-rooms',
				path: 'select-rooms'
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 777));
				}
			},
			name: 'bookings',
			path: 'bookings',
			meta: {
				breadcrumb: 'Reservas'
			},
			redirect: '/bookings/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 798));
				},
				name: 'booking-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 299));
				},
				name: 'booking-new',
				path: 'new/:id/:amountPayment',
				meta: {
					breadcrumb: 'Nueva'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 299));
				},
				name: 'booking-edit',
				path: ':codeBooking/edit',
				meta: {
					breadcrumb: 'Editar'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 796));
				},
				name: 'booking-detail',
				path: ':bookingCode/detail',
				meta: {
					breadcrumb: 'Detalle'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 797));
				},
				name: 'booking-filter',
				path: 'query',
				meta: {
					breadcrumb: 'Consulta'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 781));
				}
			},
			name: 'channels',
			path: 'otas',
			meta: {
				breadcrumb: 'OTAS'
			},
			redirect: '/otas/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 805));
				},
				name: 'channels-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 300));
				},
				name: 'channels-new',
				path: 'new',
				meta: {
					breadcrumb: 'Nuevo'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(16/* duplicate */).then(__webpack_require__.bind(null, 300));
				},
				name: 'channels-config',
				path: ':channelId/config',
				meta: {
					breadcrumb: 'Editar'
				},
				props: true
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 792));
				}
			},
			name: 'units',
			path: '/units',
			meta: {
				breadcrumb: 'Unidades'
			},
			redirect: '/units/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 837));
				},
				name: 'units-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 780));
				}
			},
			name: 'categories',
			path: '/categories',
			meta: {
				breadcrumb: 'Categorías'
			},
			redirect: '/categories/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 804));
				},
				name: 'categories-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 790));
				}
			},
			name: 'clerkinn-rooms',
			path: '/new-rooms',
			meta: {
				breadcrumb: 'Habitaciones'
			},
			redirect: '/new-rooms/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 831));
				},
				name: 'rooms-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 778));
				}
			},
			name: 'buildings',
			path: '/buildings',
			meta: {
				breadcrumb: 'Edificios'
			},
			redirect: '/buildings/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 799));
				},
				name: 'buildings-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 791));
				}
			},
			name: 'sales',
			path: '/sales',
			meta: {
				breadcrumb: 'Ventas'
			},
			redirect: '/sales/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 833));
				},
				name: 'sales-list',
				path: 'list',
				meta: {
					breadcrumb: 'Lista'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 832));
				},
				name: 'sale-detail',
				path: ':id/detail',
				meta: {
					breadcrumb: 'Detalle'
				},
				props: true
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 787));
				}
			},
			name: 'planning',
			path: '/planning',
			meta: {
				breadcrumb: 'Planning'
			},
			redirect: '/planning/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 821));
				},
				name: 'planning-list',
				path: 'list'
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 784));
				}
			},
			name: 'dashboard-clerkinn',
			path: '/dashboard',
			meta: {
				breadcrumb: 'Dashboard'
			},
			redirect: '/dashboard',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 813));
				},
				name: 'dashboard-clerkinn-main',
				path: ''
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 788));
				}
			},
			name: 'pos-clerkinn',
			path: '/pos',
			meta: {
				breadcrumb: 'POS'
			},
			redirect: '/pos',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 822));
				},
				name: 'pos',
				path: ''
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 803));
				}
			},
			meta: {
				breadcrumb: 'Adelanto'
			},
			name: 'prepayment',
			path: '/booking/:bookingCode/prepayment',
			redirect: '/booking/:bookingCode/prepayment',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 802));
				},
				name: 'list-prepayment',
				path: '/booking/:bookingCode/prepayment',
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 801));
				},
				name: 'form-prepayment',
				path: ':idDocument/form',
				props: true
			}]
		}, {
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 811));
				}
			},
			meta: {
				breadcrumb: 'Empresas'
			},
			name: 'companies',
			path: '/company',
			redirect: '/company/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 809));
				},
				name: 'companies-list',
				path: 'list'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 301));
				},
				name: 'companies-new',
				path: 'new',
				meta: {
					breadcrumb: 'Nueva'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 301));
				},
				name: 'companies-edit',
				path: ':id/edit',
				meta: {
					breadcrumb: 'Editar'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 810));
				},
				name: 'companies-statistics',
				path: ':id/statistics',
				meta: {
					breadcrumb: 'Estadísticas'
				},
				props: true
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 808));
				},
				name: 'companies-history',
				path: ':id/history',
				meta: {
					breadcrumb: 'Historial'
				},
				props: true
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 795));
			},
			name: 'blocking',
			path: 'blocking',
			meta: {
				breadcrumb: 'Bloquear Canales'
			}
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 835));
			},
			name: 'sellers',
			path: 'sellers',
			redirect: '/sellers/list',
			meta: {
				breadcrumb: 'Vendedores'
			},
			children: [{
				name: 'sellers-list',
				path: 'list',
				component: function component() {
					return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 834));
				}
			}, {
				name: 'sellers-new',
				path: 'new',
				meta: {
					breadcrumb: 'Crear vendedor'
				},
				component: function component() {
					return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 308));
				}
			}, {
				name: 'sellers-edit',
				path: 'edit/:sellerId',
				meta: {
					breadcrumb: 'Editar vendedor'
				},
				component: function component() {
					return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 308));
				}
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 840));
			},
			meta: {
				breadcrumb: 'Usuarios'
			},
			name: 'user',
			path: 'user',
			redirect: '/user/list',
			children: [{
				component: function component() {
					return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 839));
				},
				name: 'user-list',
				path: 'list'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 838));
				},
				name: 'user-activities',
				path: 'activity'
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 309));
				},
				name: 'config-user',
				path: 'edit',
				meta: {
					breadcrumb: 'Editar Usuario'
				}
			}, {
				component: function component() {
					return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 309));
				},
				name: 'new-user',
				path: 'new',
				meta: {
					breadcrumb: 'Nuevo Usuario'
				}
			}]
		}, {
			component: function component() {
				return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 774));
			},
			name: 'employment-component',
			path: 'employment-component'
		}],
		components: {
			default: __WEBPACK_IMPORTED_MODULE_3__components_Layout___default.a
		},
		name: 'home',
		path: '/',
		redirect: '/dashboard'
	}, {
		components: {
			login: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a
		},
		name: 'login',
		path: '/login'
	}, {
		component: __WEBPACK_IMPORTED_MODULE_19__components_NotFound___default.a,
		name: 'notfound',
		path: '*'
	}]
});

router.beforeEach(function (to, from, next) {
	if (to.name !== 'login') {
		var token = window.localStorage.getItem("housekeeping" + '::token');
		if (token) {
			return next();
		}
		return next({ name: 'login' });
	}
	return next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(742),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(746),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a483313",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return round; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);


var methods = {};

var currency = function currency(amount) {
	var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$';
	return symbol + ' ' + amount || symbol + ' 0.00';
};

var round = function round(value) {
	var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	if (value && typeof value === 'number') {
		return value.toFixed(decimals);
	}
	if (typeof value === 'undefined' || value === null) {
		return '0.00';
	} else if (typeof value === 'string') {
		return value;
	}
	return '0.00';
};

var parseDate = function parseDate(date) {
	var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';

	if (date) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(date, option);
	}
	return null;
};

var truncate = function truncate(string) {
	var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 22;

	if (string.length <= length) {
		return string;
	}
	return string.substring(0, length) + '...';
};

/* unused harmony default export */ var _unused_webpack_default_export = (methods);

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(751),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a0542ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(740),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-396e84b1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(557)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(738),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35d1e9a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(749),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-668d8886",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(745),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56694285",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(734),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d7d19c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
	apiKey: "AIzaSyDSLRQ01UbEyFbac-GyvaaocGxMAL7GA_Q",
	authDomain: "feedbackinn.firebaseapp.com",
	databaseURL: "https://feedbackinn.firebaseio.com",
	projectId: "feedbackinn",
	storageBucket: "feedbackinn.appspot.com",
	messagingSenderIdd: "110926697757"
};

__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_firebase___default.a);

var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database();

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuefire__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vddl__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vddl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vddl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resource_index__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_type_document__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_type_document___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_app_type_document__);

















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vddl___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('app-type-document', __WEBPACK_IMPORTED_MODULE_15__components_app_type_document___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
	load: {
		key: 'AIzaSyCjVhVe8HfJJVI57btvbnX0EmFTipO5uI4',
		libraries: 'places'
	}
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.lang = 'es';

var i18n = new __WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]({
	locale: 'es'
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$locale = {
	change: function change(language) {
		i18n.locale = language;
	},
	current: function current() {
		return i18n.locale;
	}
};

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */

function loadLanguages() {
	fetch('/static/locales.json').then(function (response) {
		var data = response.json();
		return data;
	}).then(function (json) {
		i18n.setLocaleMessage('es', json.es);
		i18n.setLocaleMessage('en', json.en);
		__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.options.root = "//panel.housekeepinn.com/housekeeping-module";
		__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$imageS3 = "//picture-controlinn.s3.amazonaws.com";
		__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.interceptors.push(__WEBPACK_IMPORTED_MODULE_13__resource_index__["a" /* default */].interceptor);
		Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype, '$breadcrumbsItems', {
			get: function get() {
				var _this = this;

				var crumbs = [];
				var matched = this.$route.matched;
				matched.forEach(function (route) {
					var breadcrumbItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, route);
					var hasBreadcrumb = route.meta && route.meta.breadcrumb;
					if (hasBreadcrumb) {
						if (_this.$route.name === route.name) {
							breadcrumbItem.params = _this.$route.params;
						}
						crumbs.push(breadcrumbItem);
					}
				});
				return crumbs.map(function (crumb) {
					return {
						id: crumb.name,
						disabled: false,
						text: crumb.meta.breadcrumb,
						href: crumb.path ? crumb.path : '/dashboard',
						params: crumb.params,
						extension: crumb.path === '/transfers' ? 'png' : 'svg'
					};
				});
			}
		});
	}).then(function () {
		var token = __WEBPACK_IMPORTED_MODULE_14__shared_helper__["a" /* default */].methods.getToken();
		if (token) {
			return fetch('//pms.controlinn.com/api' + '/employee-code', {
				headers: {
					authorization: 'Bearer ' + token
				}
			}).then(function (res) {
				return res.json();
			});
		}
		return false;
	}).then(function (employee) {
		if (employee) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$userInfo = employee.data;
			window.localStorage.setItem("housekeeping", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(employee.data));
		}

		new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
			el: '#app',
			i18n: i18n,
			router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
			template: '<App/>',
			components: { App: __WEBPACK_IMPORTED_MODULE_11__App___default.a }
		});
	});
}

loadLanguages();

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__(65);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function onEventSnack(options) {
	this.snackbar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options);
}

function created() {
	var _this = this;

	__WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$on('SNACK_BAR', onEventSnack.bind(this));
	__WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$on('show-progress', function (result) {
		_this.showProgress = result;
	});
}

function toggleSnackBar() {
	this.snackbar.visible = !this.snackbar.visible;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	created: created,
	data: function data() {
		return {
			snackbar: {
				visible: false,
				message: ''
			},
			showProgress: false
		};
	},

	methods: {
		toggleSnackBar: toggleSnackBar
	},
	name: 'app'
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'guest'
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'laundry'
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'minibar'
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'products'
});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'transfers'
});

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_firebase__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bus__ = __webpack_require__(65);




var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var user, headers, url, sidebarParams, _ref2, sidebar;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						user = this.helperMethods.getUser();
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};

						this.localLanguage = localStorage.getItem("housekeeping" + '::language');
						if (!this.localLanguage) {
							localStorage.setItem("housekeeping" + '::language', 'es');
							this.localLanguage = localStorage.getItem("housekeeping" + '::language');
						}

						if (!user) {
							_context.next = 14;
							break;
						}

						this.user.fullName = this.buildUserFullName(user);
						this.user.url_image = '';
						url = '//acl.japisale.com/api' + '/sidebar/' + 'clerkinn';
						sidebarParams = {
							languages: this.localLanguage
						};
						_context.next = 11;
						return this.$http.get(url, { params: sidebarParams, headers: headers });

					case 11:
						_ref2 = _context.sent;
						sidebar = _ref2.data;

						this.sidebar = sidebar.data.map(function (menu) {
							var newMenu = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, menu);
							newMenu.active = false;
							newMenu.resource.data.sort(function (a, b) {
								return a.position - b.position;
							});
							return newMenu;
						}).sort(function (a, b) {
							return a.position - b.position;
						});

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var logout = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return this.$http.post('//acl.japisale.com/api' + '/logout');

					case 2:
						window.localStorage.clear();
						this.$router.push(this.loginHref);

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function logout() {
		return _ref3.apply(this, arguments);
	};
}();

var deleteNotification = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
		var code = _ref6.code;
		var url;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						url = '//pms.controlinn.com/api' + '/booking/' + code + '/asignedroom';
						_context3.next = 3;
						return this.$http.delete(url);

					case 3:
						this.loadData();

					case 4:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function deleteNotification(_x) {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var helperData = __WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].data();

function created() {
	this.helperMethods = __WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].methods;
	var employee = this.helperMethods.getUser();
	this.companyId = employee.employeeCompany.data.id;
	this.loadData();
	this.loadNotifications();
}

function mounted() {
	var _this = this;

	var token = localStorage.getItem("housekeeping" + '::token');
	if (token) {
		window.addEventListener('click', function (event) {
			if (document.getElementById('notifications').contains(event.target) || document.getElementById('buttonNotifications').contains(event.target)) {
				_this.doNothing = true;
			} else {
				_this.notificationsList = false;
			}
		});
	}
}

function deleteHousemaidAssignData() {
	if (this.$route.name !== 'housemaids-assign') {
		this.helperMethods.removeHousemaidAssign();
	}
}

function firstItem(index) {
	return index === 0;
}

function buildUserFullName(user) {
	return user.name + ' ' + user.lastname;
}

function loadNotifications() {
	this.$bindAsArray('notifications', __WEBPACK_IMPORTED_MODULE_3__shared_firebase__["a" /* db */].ref('Reservations/' + this.companyId));
}

function notificationsQuantity() {
	var self = this;
	this.newNotification = this.notifications.length > 0;
	setTimeout(function () {
		self.newNotification = false;
	}, 2000);
	return this.notifications.length;
}

function openNotifications() {
	this.notificationsList = !this.notificationsList;
}

function selectData(_ref4) {
	var code = _ref4.code;

	this.$router.push({ name: 'calendar', params: { bookingCode: code } });
	this.notificationsList = false;
}

function setLanguage(lang) {
	localStorage.setItem("housekeeping" + '::language', lang);
	this.localLanguage = lang;
	this.loadData();
	__WEBPACK_IMPORTED_MODULE_7__bus__["a" /* default */].$emit('get-language', lang);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'layout',
	computed: {
		deleteHousemaidAssignData: deleteHousemaidAssignData,
		notificationsQuantity: notificationsQuantity
	},
	created: created,
	data: function data() {
		return {
			companyId: 0,
			dialog: false,
			doNothing: false,
			drawer: true,
			helperMethods: null,
			languages: {
				es: {
					id: 'ES',
					img: helperData.flagEs,
					name: 'Español'
				},
				en: {
					id: 'EN',
					img: helperData.flagEn,
					name: 'English'
				}
			},
			localLanguage: '',
			loginHref: { name: 'login' },
			newNotification: false,
			notifications: [],
			notificationsList: false,
			sidebar: [],
			user: {
				fullName: '',
				url_image: ''
			}
		};
	},

	filters: {
		parseDate: __WEBPACK_IMPORTED_MODULE_6__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_6__shared_filters__["c" /* round */]
	},
	methods: {
		buildUserFullName: buildUserFullName,
		deleteNotification: deleteNotification,
		firstItem: firstItem,
		loadData: loadData,
		loadNotifications: loadNotifications,
		logout: logout,
		openNotifications: openNotifications,
		selectData: selectData,
		setLanguage: setLanguage
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */],
	mounted: mounted
});

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_mixins__ = __webpack_require__(56);




var authenticate = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var loginUrl, _ref2, user;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.loading = true;
						loginUrl = '//acl.japisale.com/api';
						_context.prev = 2;
						_context.next = 5;
						return this.$http.post(loginUrl + '/authenticate', this.model);

					case 5:
						_ref2 = _context.sent;
						user = _ref2.data;

						this.getEmployeeData(user);
						_context.next = 14;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](2);

						this.showNotification('Correo o contraseña incorrectas', 'error');
						this.loading = false;

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 10]]);
	}));

	return function authenticate() {
		return _ref.apply(this, arguments);
	};
}();

var getEmployeeData = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(user) {
		var dashboardHref, _ref4, employee, userData;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						dashboardHref = { name: 'cms-calendar' };
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.get('//pms.controlinn.com/api' + '/employee-code', {
							headers: {
								authorization: 'Bearer ' + user.token
							}
						});

					case 4:
						_ref4 = _context2.sent;
						employee = _ref4.data;
						userData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(employee.data);

						localStorage.setItem("housekeeping", userData);
						localStorage.setItem("housekeeping" + '::token', user.token);
						this.$router.push(dashboardHref);

					case 10:
						_context2.prev = 10;

						this.loading = false;
						return _context2.finish(10);

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1,, 10, 13]]);
	}));

	return function getEmployeeData(_x) {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var initialLanguages = [{ value: 'ES', text: 'Español' }, { value: 'EN', text: 'English' }, { value: 'ZH-S', text: '简体中文' }, { value: 'ZH-T', text: '繁体中文' }];

function login() {
	this.authenticate();
}

function validateEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var _this = this;

		return {
			currentLanguage: { value: 'ES', text: 'Español' },
			emailRules: [function (email) {
				return !!email || 'Este campo es requerido';
			}, function (email) {
				return _this.validateEmail(email) || 'Debe ingresar un correo válido';
			}],
			languages: initialLanguages,
			loading: false,
			model: {
				codeApp: 'clerkinn',
				email: null,
				password: null
			},
			passwordRules: [function (password) {
				return !!password || 'Este campo es requerido';
			}],
			rememberLogin: false,
			valid: false
		};
	},

	methods: {
		authenticate: authenticate,
		getEmployeeData: getEmployeeData,
		login: login,
		validateEmail: validateEmail
	},
	mixins: __WEBPACK_IMPORTED_MODULE_3__shared_mixins__["a" /* default */],
	name: 'login'
});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


function documentName() {
	if (this.documentId === 1) {
		return 'DNI';
	} else if (this.documentId === 2) {
		return 'Pasaporte';
	} else if (this.documentId === 3) {
		return 'C. Extranjería';
	} else if (this.documentId === 4) {
		return 'RUC';
	} else if (this.documentId === 5) {
		return 'C.I. País Residencia';
	}
	return ' - ';
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app-type-document',
	computed: {
		documentName: documentName
	},
	props: {
		documentId: {
			type: Number,
			default: 0
		}
	}
});

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopupMaid__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopupMaid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopupMaid__);
//
//
//
//
//
//
//
//
//




function actionAvatar(value) {
	if (value === 1) {
		this.showPopup = false;
	} else {
		this.showPopup = !this.showPopup;
	}
}

function avatarLetters() {
	var firstLetterName = this.firstname.substring(0, 1);
	var firstLetterLastName = this.lastname.substring(0, 1);
	return '' + firstLetterName + firstLetterLastName;
}

function avatarStyle() {
	return 'background-color:' + this.color + ';height:' + this.height + ';width:' + this.width;
}

function data() {
	return {
		showPopup: false
	};
}

function editMaid() {
	this.$router.push({ name: 'users-config', params: { userId: this.$attrs.id } });
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'avatar-profile',
	components: {
		PopupMaid: __WEBPACK_IMPORTED_MODULE_0__PopupMaid___default.a
	},
	computed: {
		avatarLetters: avatarLetters,
		avatarStyle: avatarStyle
	},
	data: data,
	props: {
		color: {
			type: String,
			default: '#00ca52'
		},
		firstname: {
			type: String,
			required: true
		},
		height: {
			type: String,
			default: '26px'
		},
		lastname: {
			type: String,
			required: true
		},
		time: {
			type: String,
			default: ''
		},
		typeCleaning: {
			type: String,
			default: ''
		},
		width: {
			type: String,
			default: '26px'
		}
	},
	methods: {
		actionAvatar: actionAvatar,
		editMaid: editMaid
	}
});

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function functionClick() {
	this.$emit('function-click');
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'button-create',
	methods: {
		functionClick: functionClick
	},
	props: {
		btnFunction: {
			default: false,
			type: Boolean
		},
		disabled: {
			default: false,
			type: Boolean
		},
		href: {
			type: [String, Object],
			default: '/'
		},
		text: {
			type: String
		}
	}
});

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


function data() {
	return {
		filters: [{
			id: 1, value: 1, label: 'Todos'
		}, {
			id: 2, value: 2, label: 'Activado'
		}, {
			id: 3, value: 3, label: 'Desactivado'
		}]
	};
}

function selectFilter(filter) {
	this.$emit('selected-filter', filter);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filter-list',
	data: data,
	props: {
		value: {
			type: [Number],
			default: 1
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		selectFilter: selectFilter
	}
});

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function actionButton() {
	this.$emit('action-popup');
}

function closePopup() {
	this.$emit('close-popup');
}

function style() {
	var opacityValue = this.visible ? 1 : 0;
	var translate = this.visible ? -20 : 0;
	var zIndexValue = this.visible ? 1 : -1;
	return 'opacity:' + opacityValue + ';transform:translateY(' + translate + 'px);z-index:' + zIndexValue;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'popup-maid',
	computed: {
		style: style
	},
	props: {
		name: {
			type: String,
			default: 'Maria Chiappe'
		},
		time: {
			type: String,
			default: '9:30 a.m.'
		},
		typeCleaning: {
			type: String,
			default: 'Profunda'
		},
		visible: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		actionButton: actionButton,
		closePopup: closePopup
	}
});

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function goToLink(link) {
	if (this.tag !== 'label') {
		this.$router.push(link);
	}
}

function roomSelected(room) {
	if (this.tag === 'label') {
		this.$emit('on-room-selected', room);
	}
}

function onRoomRemove(room) {
	this.$emit('on-room-removed', room);
}

function clickEdit() {
	this.$emit('on-click-edit', true);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		clickEdit: clickEdit,
		goToLink: goToLink,
		onRoomRemove: onRoomRemove,
		roomSelected: roomSelected
	},
	name: 'room-number-list',
	props: {
		index: {
			type: [String, Number]
		},
		room: {
			type: Object,
			required: true
		},
		labelFor: {
			type: [String, Number]
		},
		tag: {
			type: String,
			default: 'a'
		},
		link: {
			type: String
		},
		editIsActive: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function onChange(value) {
	var newValue = value;
	newValue.isAdded = newValue.isSelected;
	this.$emit('on-room-selected', newValue);
}

function created() {
	if (this.nameState) {
		this.styleRoom = 'display: inline-block';
	}
}

function removeOfList(id) {
	this.$emit('on-room-removed', id);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	created: created,
	data: function data() {
		return {
			styleRoom: ''
		};
	},

	methods: {
		onChange: onChange,
		removeOfList: removeOfList
	},
	name: 'room-status',
	props: {
		backgroundColor: {
			type: String
		},
		cleanState: {
			type: Number,
			default: 1
		},
		number: {
			type: [Number, String]
		},
		code: {
			type: String
		},
		size: {
			type: String,
			default: 'large'
		},
		name: {
			type: String,
			default: null
		},
		statusIcon: {
			type: String,
			default: null
		},
		statusIconImg: {
			type: String,
			default: null
		},
		isAdded: {
			type: Boolean,
			default: false
		},
		extraState: {
			type: String,
			default: null
		},
		labelFor: {
			type: [Number, String]
		},
		room: {
			type: Object
		},
		roomId: {
			type: Number
		},
		showCircle: {
			type: Boolean,
			default: false
		},
		stateCode: {
			type: String,
			default: ''
		},
		nameState: {
			type: String,
			default: ''
		}
	}
});

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabs-component',
	props: {
		tabs: {
			type: Array,
			required: true
		}
	}
});

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function radioOnChange(value) {
	this.$emit('radio-on-change', value);
}

function removeOfList() {
	this.$emit('on-user-removed');
}

/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		radioOnChange: radioOnChange,
		removeOfList: removeOfList
	},
	name: 'user-selector',
	props: {
		user: {
			type: Object,
			required: true
		}
	}
});

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserSelector__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserSelector__);
//
//
//
//
//
//
//
//
//
//



function changeSelected(user) {
	this.$emit('on-change-selected', user);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		UserSelector: __WEBPACK_IMPORTED_MODULE_0__UserSelector___default.a
	},
	methods: {
		changeSelected: changeSelected
	},
	name: 'user-selector-list',
	props: {
		users: {
			type: Array,
			required: true
		}
	}
});

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'dashboard'
});

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_RoomStatus__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_RoomStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_RoomStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_TabsComponent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_TabsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_TabsComponent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function mounted() {
	this.states = [{
		id: 1,
		name: 'Ocupado sucio',
		rooms_quantity: 5,
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			name: 'OS',
			clean_state: 1
		}, {
			id: 2,
			roomtype_name: 'Suite',
			number: '5313',
			code: 'STE',
			clean_state: 1
		}, {
			id: 3,
			roomtype_name: 'Standard',
			number: '5314',
			code: 'STD',
			clean_state: 1
		}, {
			id: 4,
			roomtype_name: 'Other',
			number: '5315',
			code: 'OTH',
			clean_state: 1
		}, {
			id: 5,
			roomtype_name: 'Another',
			number: '5316',
			code: 'ATH',
			clean_state: 1
		}]
	}, {
		id: 2,
		name: 'Vacante sucio',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5412',
			code: 'DLX',
			clean_state: 2
		}, {
			id: 2,
			roomtype_name: 'Suite',
			number: '5413',
			code: 'DLX',
			clean_state: 2
		}, {
			id: 3,
			roomtype_name: 'Standard',
			number: '5414',
			code: 'DLX',
			clean_state: 2
		}]
	}, {
		id: 3,
		name: 'Turn Over',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5420',
			code: 'DLX',
			clean_state: 3
		}]
	}, {
		id: 4,
		name: 'Mantenimiento',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5421',
			code: 'DLX',
			clean_state: 4
		}, {
			id: 2,
			roomtype_name: 'Standard',
			number: '5427',
			code: 'STD',
			clean_state: 4
		}]
	}, {
		id: 4,
		name: 'Limpieza Profunda',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5423',
			code: 'DLX',
			clean_state: 5
		}, {
			id: 2,
			roomtype_name: 'Standard',
			number: '5424',
			code: 'STD',
			clean_state: 5
		}, {
			id: 3,
			roomtype_name: 'Suite',
			number: '5430',
			code: 'STE',
			clean_state: 5
		}, {
			id: 4,
			roomtype_name: 'Other',
			number: '5432',
			code: 'OTH',
			clean_state: 5
		}]
	}, {
		id: 5,
		name: 'Ocupado Limpio',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5423',
			code: 'DLX',
			clean_state: 1
		}, {
			id: 2,
			roomtype_name: 'Standard',
			number: '5424',
			code: 'STD',
			clean_state: 1
		}, {
			id: 3,
			roomtype_name: 'Suite',
			number: '5430',
			code: 'STE',
			clean_state: 1
		}, {
			id: 4,
			roomtype_name: 'Other',
			number: '5432',
			code: 'OTH',
			clean_state: 1
		}, {
			id: 5,
			roomtype_name: 'Standard',
			number: '5424',
			code: 'STD',
			clean_state: 1
		}, {
			id: 6,
			roomtype_name: 'Suite',
			number: '5430',
			code: 'STE',
			clean_state: 1
		}, {
			id: 7,
			roomtype_name: 'Other',
			number: '5432',
			code: 'OTH',
			clean_state: 1
		}]
	}, {
		id: 6,
		name: 'Vacante Limpio',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5423',
			code: 'DLX',
			clean_state: 2
		}, {
			id: 2,
			roomtype_name: 'Standard',
			number: '5424',
			code: 'STD',
			clean_state: 2
		}, {
			id: 3,
			roomtype_name: 'Suite',
			number: '5430',
			code: 'STE',
			clean_state: 2
		}, {
			id: 4,
			roomtype_name: 'Other',
			number: '5432',
			code: 'OTH',
			clean_state: 2
		}]
	}, {
		id: 6,
		name: 'Fuera de servicio',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5423',
			code: 'DLX',
			clean_state: 6
		}, {
			id: 2,
			roomtype_name: 'Standard',
			number: '5424',
			code: 'STD',
			clean_state: 6
		}, {
			id: 3,
			roomtype_name: 'Suite',
			number: '5430',
			code: 'STE',
			clean_state: 6
		}, {
			id: 4,
			roomtype_name: 'Other',
			number: '5432',
			code: 'OTH',
			clean_state: 6
		}, {
			id: 5,
			roomtype_name: 'Other',
			number: '5432',
			code: 'OTH',
			clean_state: 6
		}]
	}, {
		id: 7,
		name: 'Bloqueado',
		rooms: [{
			id: 1,
			roomtype_name: 'Deluxe',
			number: '5423',
			code: 'DLX',
			clean_state: 7
		}, {
			id: 2,
			roomtype_name: 'Standard',
			number: '5424',
			code: 'STD',
			clean_state: 7
		}, {
			id: 3,
			roomtype_name: 'Suite',
			number: '5430',
			code: 'STE',
			clean_state: 7
		}]
	}, {
		id: 8,
		name: 'Gimnasio',
		rooms: [{
			id: 1,
			roomtype_name: 'Piso 8',
			number: 'Piso 8',
			code: 'G',
			clean_state: 8
		}]
	}, {
		id: 9,
		name: 'Pasadizo',
		rooms: [{
			id: 1,
			roomtype_name: 'Piso 1',
			number: 'Piso 1',
			code: 'P',
			clean_state: 9
		}, {
			id: 2,
			roomtype_name: 'Piso 2',
			number: 'Piso 2',
			code: 'P',
			clean_state: 9
		}, {
			id: 3,
			roomtype_name: 'Piso 3',
			number: 'Piso 3',
			code: 'P',
			clean_state: 9
		}, {
			id: 4,
			roomtype_name: 'Piso 4',
			number: 'Piso 4',
			code: 'P',
			clean_state: 9
		}]
	}];
	this.maidsNames = [{
		id: 1,
		name: 'Maria Chiappe',
		qualification: 1,
		room: 504
	}, {
		id: 2,
		name: 'Maria Ramirez',
		qualification: 2,
		room: 505
	}, {
		id: 3,
		name: 'Maria Rodriguez',
		qualification: 3,
		room: 506
	}, {
		id: 1,
		name: 'Maria Chiappe',
		qualification: 1,
		room: 504
	}, {
		id: 2,
		name: 'Maria Ramirez',
		qualification: 2,
		room: 505
	}, {
		id: 3,
		name: 'Maria Rodriguez',
		qualification: 3,
		room: 506
	}, {
		id: 1,
		name: 'Maria Chiappe',
		qualification: 1,
		room: 504
	}, {
		id: 2,
		name: 'Maria Ramirez',
		qualification: 2,
		room: 505
	}, {
		id: 3,
		name: 'Maria Rodriguez',
		qualification: 3,
		room: 506
	}, {
		id: 1,
		name: 'Maria Chiappe',
		qualification: 1,
		room: 504
	}, {
		id: 2,
		name: 'Maria Ramirez',
		qualification: 2,
		room: 505
	}, {
		id: 3,
		name: 'Maria Rodriguez',
		qualification: 3,
		room: 506
	}, {
		id: 1,
		name: 'Maria Chiappe',
		qualification: 1,
		room: 504
	}, {
		id: 2,
		name: 'Maria Ramirez',
		qualification: 2,
		room: 505
	}, {
		id: 3,
		name: 'Maria Rodriguez',
		qualification: 3,
		room: 506
	}, {
		id: 1,
		name: 'Maria Chiappe',
		qualification: 1,
		room: 504
	}, {
		id: 2,
		name: 'Maria Ramirez',
		qualification: 2,
		room: 505
	}, {
		id: 3,
		name: 'Maria Rodriguez',
		qualification: 3,
		room: 506
	}, {
		id: 1,
		name: 'Maria Chiappe',
		qualification: 1,
		room: 504
	}, {
		id: 2,
		name: 'Maria Ramirez',
		qualification: 2,
		room: 505
	}];
}

/* harmony default export */ __webpack_exports__["default"] = ({
	mounted: mounted,
	components: {
		RoomStatus: __WEBPACK_IMPORTED_MODULE_0__components_shared_RoomStatus___default.a,
		TabsComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_TabsComponent___default.a
	},
	name: 'dashboard-sales',
	data: function data() {
		return {
			e1: null,
			e2: null,
			e3: null,
			e4: null,
			e5: null,
			e6: null,
			e7: null,
			items: [{ text: 'Sucursal 1' }, { text: 'Sucursal 2' }, { text: 'Sucursal 3' }, { text: 'Sucursal 4' }],
			buildings: [{ text: 'Building 1' }, { text: 'Building 2' }, { text: 'Building 3' }, { text: 'Building 4' }],
			rooms: [{ text: 'Room 1' }, { text: 'Room 2' }, { text: 'Room 3' }, { text: 'Room 4' }],
			startDate: [{ text: 'Start Date 1' }, { text: 'Start Date 2' }, { text: 'Start Date 3' }, { text: 'Start Date 4' }],
			finishDate: [{ text: 'Finish Date 1' }, { text: 'Finish Date 2' }, { text: 'Finish Date 3' }, { text: 'Finish Date 4' }],
			general: [{ text: 'General 1' }, { text: 'General 2' }, { text: 'General 3' }, { text: 'General 4' }],
			statusType: [{ text: 'Status 1' }, { text: 'Status 2' }, { text: 'Status 3' }, { text: 'Status 4' }],
			states: [],
			maidsNames: [],
			tabs: [{
				id: 1,
				title: 'Trabajadores',
				link: '/dashboard'
			}, {
				id: 2,
				title: 'Ventas',
				link: '/dashboard/sales'
			}]
		};
	}
});

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'housemaids'
});

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__);
//
//
//
//
//
//
//




function data() {
	return {
		tabs: [{
			id: 1,
			title: 'Por Solucionar',
			link: { name: 'unresolved-maintenance' }
		}, {
			id: 2,
			title: 'Solucionados',
			link: { name: 'solved-maintenance' }
		}]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'maintenance-container',
	components: {
		TabsComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default.a
	},
	data: data
});

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_FilterList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_RoomNumberList__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_RoomNumberList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_RoomNumberList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_TabsComponent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_TabsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_TabsComponent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function columnSortableEvent(id) {
	var _this = this;

	setTimeout(function () {
		var newData = [];
		var newColumn = _this.columns.filter(function (column) {
			return column.id === id;
		});
		newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
		var columnName = newColumn[0].code;
		if (newColumn[0].isSortable.up) {
			newData = _this.rows.sort(function (a, b) {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return a[columnName] - b[columnName];
				}
				return a[columnName].charCodeAt() - b[columnName].charCodeAt();
			});
		} else {
			newData = _this.rows.sort(function (a, b) {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return b[columnName] - a[columnName];
				}
				return b[columnName].charCodeAt() - a[columnName].charCodeAt();
			});
		}
		_this.rows = newData;
	}, 300);
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
}

function showRooms(rooms, name, quantity) {
	this.rooms = rooms;
	this.roomTypeName = name;
	this.roomsQuantity = quantity;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'other-enviroments',
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_1__components_shared_ButtonCreate___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_2__components_shared_FilterList___default.a,
		RoomNumberList: __WEBPACK_IMPORTED_MODULE_3__components_shared_RoomNumberList___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_0_table_run___default.a,
		TabsComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_TabsComponent___default.a
	},
	data: function data() {
		return {
			columns: [{ id: 1, name: 'Room type', code: 'name', isSortable: { down: true, up: false } }, { id: 2, name: 'Quantity', code: 'quantity', isSortable: { down: true, up: false } }],
			filterValue: 1,
			rows: [{
				id: 1,
				name: 'Deluxe Room Queen',
				quantity: 8,
				flagactive: 1,
				rooms: [{
					id: 101,
					isAssigned: true,
					isSelected: false
				}, {
					id: 102,
					isAssigned: false,
					isSelected: false
				}]
			}, {
				id: 2,
				name: 'Deluxe Suite Queen',
				quantity: 25,
				flagactive: 1,
				rooms: [{
					id: 103,
					isAssigned: true,
					isSelected: false
				}, {
					id: 104,
					isAssigned: false,
					isSelected: false
				}]
			}, {
				id: 3,
				name: 'Deluxe Suite Twin',
				quantity: 3,
				flagactive: 1,
				rooms: [{
					id: 105,
					isAssigned: true,
					isSelected: false
				}, {
					id: 106,
					isAssigned: false,
					isSelected: false
				}]
			}, {
				id: 4,
				name: 'Executive Suite Queen',
				quantity: 3,
				flagactive: 1,
				rooms: [{
					id: 107,
					isAssigned: true,
					isSelected: false
				}, {
					id: 108,
					isAssigned: false,
					isSelected: false
				}]
			}, {
				id: 5,
				name: 'Superior Suite Queen',
				quantity: 1,
				flagactive: 1,
				rooms: [{
					id: 109,
					isAssigned: true,
					isSelected: false
				}, {
					id: 110,
					isAssigned: false,
					isSelected: false
				}]
			}],
			rooms: [],
			roomTypeName: '',
			roomsQuantity: null,
			tabs: [{
				id: 1,
				title: 'Rooms',
				link: '/rooms'
			}, {
				id: 2,
				title: 'Other enviroments',
				link: '/other-enviroments'
			}]
		};
	},

	methods: {
		columnSortableEvent: columnSortableEvent,
		selectedFilter: selectedFilter,
		showRooms: showRooms
	}
});

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_UserSelectorList__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_UserSelectorList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_UserSelectorList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_Calendar__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__calendar_Calendar__);



var assignMaid = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.isLoading = true;
						this.showModal = false;
						_context.prev = 2;
						_context.next = 5;
						return this.$http.post('assign-maid', this.model);

					case 5:
						this.showNotification('Mucama asignada correctamente');
						this.loadData();
						this.isLoading = false;
						_context.next = 14;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](2);

						this.showNotification('Error al asignar mucama', 'error');
						this.isLoading = false;

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 10]]);
	}));

	return function assignMaid() {
		return _ref.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.cleanTypes = [{ id: 1, name: 'Normal' }, { id: 2, name: 'Profunda' }];
						this.maids = loadFakeMaids();
						this.rooms = loadNewRooms();
						this.generateDays();
						_context2.prev = 4;
						_context2.next = 7;
						return this.$http.get('calendar/' + this.month + '/' + this.year);

					case 7:
						response = _context2.sent;

						this.rooms = response.data;
						_context2.next = 14;
						break;

					case 11:
						_context2.prev = 11;
						_context2.t0 = _context2['catch'](4);

						this.mockupData();

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[4, 11]]);
	}));

	return function loadData() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var daysNames = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

function loadNewRooms() {
	var rooms = [{
		id: 1,
		number: '5201',
		type: 'DR',
		maids: [{
			id: 1,
			avatar: 'MC',
			dateShort: '10/10/2017',
			firstname: 'Maria',
			lastname: 'Chiappe',
			time: '09:30 a.m.',
			typeCleaning: 'Profunda'
		}, {
			id: 2,
			avatar: 'LA',
			dateShort: '25/10/2017',
			firstname: 'Luis',
			lastname: 'Advincula',
			time: '10:20 p.m.',
			typeCleaning: 'Profunda'
		}]
	}, {
		id: 2,
		number: '5202',
		type: 'DSQ',
		maids: [{
			id: 1,
			avatar: 'RA',
			firstname: 'Renzo',
			lastname: 'Acosta',
			dateShort: '30/10/2017',
			time: '07:20 a.m.',
			typeCleaning: 'Normal'
		}, {
			id: 2,
			avatar: 'CA',
			firstname: 'Carla',
			lastname: 'Alvarado',
			dateShort: '29/10/2017',
			time: '11:30 a.m.',
			typeCleaning: 'Profunda'
		}]
	}];
	return rooms;
}

function loadFakeMaids() {
	var maids = [];
	for (var index = 1; index < 9; index += 1) {
		maids.push({ id: index + 1, name: 'Maria ' + index, lastname: 'Chiappe ' + index, url_image: '//placecage.com/gif/47/47' });
	}
	return maids;
}

function getDayName(dayNumber) {
	return daysNames[dayNumber];
}

function generateDays() {
	var optionDate = { year: 'numeric', month: '2-digit', day: '2-digit' };
	var currentDate = new Date(this.year, this.month - 1, 1);
	var today = new Date();
	var daysValues = [];
	var index = 1;
	while (currentDate.getMonth() + 1 === this.month) {
		var currentDay = currentDate;
		var dayInfo = {
			date: new Date(currentDay),
			day: currentDay.getDate(),
			dateShort: currentDay.toLocaleDateString('es-PE', optionDate),
			dayName: getDayName(currentDay.getDay()),
			disabled: today > currentDay,
			id: index
		};
		daysValues.push(dayInfo);
		currentDate.setDate(currentDate.getDate() + 1);
		index += 1;
	}
	this.days = daysValues;
}

function mockupData() {
	var _this = this;

	this.rooms = this.rooms.map(function (room) {
		var newRoom = room;
		newRoom.maids = _this.days.map(function (day) {
			var newMaid = {};
			var maidExists = room.maids.find(function (m) {
				return m.dateShort === day.dateShort;
			});
			if (!maidExists) {
				newMaid.id = day.id;
				newMaid.avatar = '';
				newMaid.firstname = '';
				newMaid.lastname = '';
				newMaid.dateShort = day.dateShort;
				newMaid.color = '#fff';
				newMaid.disabled = day.disabled;
			} else {
				maidExists.disabled = day.disabled;
				newMaid = maidExists;
			}
			return newMaid;
		});
		return newRoom;
	});
}

function created() {
	this.loadTime();
	this.loadData();
}

function changeMonth(type) {
	if (type === 1) {
		if (this.month === 1) {
			this.month = 12;
			this.year -= 1;
		} else {
			this.month -= 1;
		}
	}
	if (type === 2) {
		if (this.month === 12) {
			this.month = 1;
			this.year += 1;
		} else {
			this.month += 1;
		}
	}
	this.loadData();
}

function isValid() {
	var result = true;
	if (this.model.maid !== null && this.model.cleanTypeSelected !== null) {
		result = false;
	}
	return result;
}

function loadTime() {
	for (var index = 1; index < 13; index += 1) {
		this.hours.push(index < 10 ? '0' + index : index);
	}
	for (var mIndex = 1; mIndex < 60; mIndex += 1) {
		this.minutes.push(mIndex < 10 ? '0' + mIndex : mIndex);
	}
}

function data() {
	return {
		cleanTypes: [],
		days: [],
		hours: [],
		isLoading: false,
		minutes: [],
		month: new Date().getMonth() + 1,
		maids: [],
		model: {
			cleanTypeSelected: null,
			comment: '',
			hour: '01',
			minute: '01',
			modeClock: 'am',
			maid: null
		},
		rooms: [{
			id: 1,
			number: '5201',
			type: 'DR',
			maids: [{
				id: 1,
				avatar: 'MC',
				dateShort: '10/10/2017',
				firstname: 'Maria',
				lastname: 'Chiappe',
				time: '09:30 a.m.',
				typeCleaning: 'Profunda'
			}, {
				id: 2,
				avatar: 'LA',
				dateShort: '25/10/2017',
				firstname: 'Luis',
				lastname: 'Advincula',
				time: '10:20 p.m.',
				typeCleaning: 'Profunda'
			}]
		}, {
			id: 2,
			number: '5202',
			type: 'DSQ',
			maids: [{
				id: 1,
				avatar: 'RA',
				firstname: 'Renzo',
				lastname: 'Acosta',
				dateShort: '30/10/2017',
				time: '07:20 a.m.',
				typeCleaning: 'Normal'
			}, {
				id: 2,
				avatar: 'CA',
				firstname: 'Carla',
				lastname: 'Alvarado',
				dateShort: '29/10/2017',
				time: '11:30 a.m.',
				typeCleaning: 'Profunda'
			}]
		}],
		showModal: false,
		today: new Date(),
		year: new Date().getFullYear()
	};
}

function onMaidSelected(maid) {
	this.model.maid = maid;
}

function openModal() {
	this.showModal = !this.showModal;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'planning-housekeeping',
	components: {
		Calendar: __WEBPACK_IMPORTED_MODULE_4__calendar_Calendar___default.a,
		UserSelectorList: __WEBPACK_IMPORTED_MODULE_3__components_shared_UserSelectorList___default.a
	},
	computed: {
		isValid: isValid
	},
	created: created,
	data: data,
	methods: {
		assignMaid: assignMaid,
		changeMonth: changeMonth,
		generateDays: generateDays,
		loadData: loadData,
		loadTime: loadTime,
		mockupData: mockupData,
		onMaidSelected: onMaidSelected,
		openModal: openModal
	},
	mixins: __WEBPACK_IMPORTED_MODULE_2__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__);
//
//
//
//
//
//
//




function data() {
	return {
		tabs: [{
			id: 1,
			title: 'Por Solucionar',
			link: { name: 'unresolved' }
		}, {
			id: 2,
			title: 'Solucionados',
			link: { name: 'solved' }
		}]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'problem-container',
	components: {
		TabsComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default.a
	},
	data: data
});

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'rooms'
});

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'settings'
});

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'states'
});

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'users'
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_AvatarProfile__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_AvatarProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_AvatarProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarHeader__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CalendarHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function onDayClick(maid, room) {
	this.$emit('on-add-day', { maid: maid, room: room });
}

function changeMonth(type) {
	this.$emit('change-month', type);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'calendar',
	components: {
		AvatarProfile: __WEBPACK_IMPORTED_MODULE_0__components_shared_AvatarProfile___default.a,
		CalendarHeader: __WEBPACK_IMPORTED_MODULE_1__CalendarHeader___default.a
	},
	methods: {
		onDayClick: onDayClick,
		changeMonth: changeMonth
	},
	props: {
		days: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		month: {
			type: Number,
			default: 10
		},
		rooms: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		year: {
			type: Number,
			default: 2017
		}
	}
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];

function changeMonth(type) {
	this.$emit('change-month', type);
}

function dateInformation() {
	var information = {
		monthName: months[this.month - 1]
	};
	return information;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'calendar-header',
	computed: {
		dateInformation: dateInformation
	},
	props: {
		month: {
			type: Number,
			default: 1
		},
		year: {
			type: Number,
			default: 2017
		}
	},
	methods: {
		changeMonth: changeMonth
	}
});

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus__ = __webpack_require__(65);




var callHttp = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url, propertyName) {
		var _this = this;

		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$http.get(url);

					case 3:
						response = _context.sent;

						if (response.data[0].name) {
							this[propertyName].push({ id: 0, name: 'All' });
						} else {
							this[propertyName].push({ id: 0, number: 'All' });
						}
						response.data.forEach(function (dataSingle) {
							_this[propertyName].push(dataSingle);
						});
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](0);

						this.showNotification('Ocurrió un error al intentar cargar la data, es probable que no se haya configurado la data necesaria.', 'error');

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 8]]);
	}));

	return function callHttp(_x, _x2) {
		return _ref.apply(this, arguments);
	};
}();

var exportToCSV = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(fieldNames, columns, rows, fileName) {
		var model, response, reader, out;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						model = {
							fieldNames: fieldNames,
							columns: columns,
							rows: rows
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.post('//products.japisale.com' + '/exports-csv', model);

					case 4:
						response = _context2.sent;
						reader = new FileReader();
						out = new Blob([response.data], { type: 'text/csv' });

						reader.onload = function () {
							var link = document.createElement('a');
							link.download = fileName + '.csv';
							link.href = reader.result;
							link.click();
						};
						reader.readAsDataURL(out);
						_context2.next = 14;
						break;

					case 11:
						_context2.prev = 11;
						_context2.t0 = _context2['catch'](1);

						this.showNotification('Error interno de servidor, por favor recargue la página e intente de nuevo', 'error');

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 11]]);
	}));

	return function exportToCSV(_x3, _x4, _x5, _x6) {
		return _ref2.apply(this, arguments);
	};
}();

var loadBookingsTotal = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(subsidiaryId) {
		var params, _ref4, bookings;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = { subsidiaryId: subsidiaryId };
						_context3.prev = 1;
						_context3.next = 4;
						return this.$http.get('//pms.controlinn.com/api' + '/bookings-details', { params: params });

					case 4:
						_ref4 = _context3.sent;
						bookings = _ref4.data;

						this.bookingsTotal = bookings.data.availabiliy.occupied;
						this.bookingsAmountTotal = bookings.data.amount;
						_context3.next = 13;
						break;

					case 10:
						_context3.prev = 10;
						_context3.t0 = _context3['catch'](1);

						this.showNotification('No se pudo calcular el total de las reservas para este hotel.', 'error');

					case 13:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[1, 10]]);
	}));

	return function loadBookingsTotal(_x7) {
		return _ref3.apply(this, arguments);
	};
}();



var SNACK_BAR_EVENT = 'SNACK_BAR';

function renderFilter(key, id, operator) {
	var filter = {
		filters: [{
			key: key,
			value: id,
			operator: operator
		}]
	};
	return filter;
}

function renderSort(key, direction) {
	var sort = {
		key: key,
		direction: direction
	};
	return sort;
}

function loadBuildingsAndSubsidiaries() {
	var _this2 = this;

	var promises = [this.$http.get('building-simple-list'), this.$http.get('subsidiary-simple-list')];
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (response) {
		_this2.buildings = response[0].data;
		_this2.subsidiaries = response[1].data;
		return [_this2.buildings, _this2.subsidiaries];
	});
}

function data() {
	return {
		bookingsAmountTotal: 0,
		bookingsTotal: 0,
		buildings: [],
		filter: [],
		page: 1,
		sort: [{
			key: 'created_at',
			direction: 'DESC'
		}],
		totalPages: 0,
		subsidiaries: [],
		rooms: [],
		roomTypes: []
	};
}

function loadBuildings() {
	callHttp.call(this, 'building-simple-list', 'buildings');
}

function loadSubsidiaries() {
	callHttp.call(this, 'subsidiary-simple-list', 'subsidiaries');
}

function loadRoomTypes() {
	callHttp.call(this, 'roomtype-simple-list', 'roomTypes');
}

function loadRooms() {
	callHttp.call(this, 'room-simple-list', 'rooms');
}

function mixinSearchCustomer(documentType, numDocument) {
	var url = Number(documentType) === 4 ? "//perudatos.controlinn.com/api" + '/ruc/' + numDocument : '//pms.controlinn.com/api' + '/customer-search';
	var params = Number(documentType) === 4 ? {} : { numDocument: numDocument, documentType: documentType };
	return this.$http.get(url, { params: params });
}

function showNotification(message) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';

	__WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$emit(SNACK_BAR_EVENT, {
		message: message,
		error: type === 'error',
		info: type === 'info',
		visible: true,
		primary: type === 'primary',
		secondary: type === 'secondary',
		success: type === 'success',
		warning: type === 'warning'
	});
}

var mixin = {
	data: data,
	methods: {
		exportToCSV: exportToCSV,
		loadBookingsTotal: loadBookingsTotal,
		loadBuildings: loadBuildings,
		loadSubsidiaries: loadSubsidiaries,
		loadRooms: loadRooms,
		loadRoomTypes: loadRoomTypes,
		loadBuildingsAndSubsidiaries: loadBuildingsAndSubsidiaries,
		mixinSearchCustomer: mixinSearchCustomer,
		renderFilter: renderFilter,
		renderSort: renderSort,
		showNotification: showNotification
	}
};

/* harmony default export */ __webpack_exports__["a"] = ([mixin]);

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);



var LOGIN_EVENT = 'LOGIN';
var PRE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/util/preimage.png';
var TURNOVER_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/turnover.svg';
var MAINTENANCE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/maintenance.svg';
var CLEANDEEP_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/cleandeep.svg';
var OUTOFSERVICE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/outofservice.svg';
var LOCKED_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/locked.svg';
var DIRTY_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/dirty.svg';
var INDETERMINATE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/housekeeping/settings/icons/indeterminate.svg';
var ES_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/webqp/flagspain.svg';
var EN_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/webqp/flagusa.png';
var PE_IMAGE_URL = '//picture-controlinn.s3.amazonaws.com/company/flags/peru.jpg';

/* eslint-disable */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function generateBlob(dataBlob) {
	var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/pdf';

	return new Blob([dataBlob], { type: contentType });
}

function getHousemaidAssign() {
	return JSON.parse(localStorage.getItem("housekeeping" + '::housemaid-assign'));
}

function getRoute(name) {
	return { name: name };
}

function getUser() {
	return JSON.parse(localStorage.getItem("housekeeping"));
}

function getToken() {
	return localStorage.getItem("housekeeping" + '::token');
}

function removeHousemaidAssign() {
	localStorage.removeItem("housekeeping" + '::housemaid-assign');
}

function removeUserData() {
	localStorage.removeItem("housekeeping");
	localStorage.removeItem("housekeeping" + '::token');
}

function saveHousemaidAssign(model) {
	return localStorage.setItem("housekeeping" + '::housemaid-assign', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
}

function showDownloadDialog(blob, name, extension, preview) {
	var currentDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate + '.' + extension;
	link.href = window.URL.createObjectURL(blob);
	link.click();
	if (preview) {
		window.open(link.href);
	}
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

	var newDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function data() {
	return {
		loginEvent: LOGIN_EVENT,
		preimageUrl: PRE_IMAGE_URL,
		turnoverImageUrl: TURNOVER_IMAGE_URL,
		maintenanceImageUrl: MAINTENANCE_IMAGE_URL,
		cleandeepImageUrl: CLEANDEEP_IMAGE_URL,
		outofserviceImageUrl: OUTOFSERVICE_IMAGE_URL,
		lockedImageUrl: LOCKED_IMAGE_URL,
		dirtyImageUrl: DIRTY_IMAGE_URL,
		indeterminateImageUrl: INDETERMINATE_IMAGE_URL,
		flagEs: ES_IMAGE_URL,
		flagEn: EN_IMAGE_URL,
		flagPe: PE_IMAGE_URL
	};
}

var helper = {
	data: data,
	methods: {
		debounce: debounce,
		formatDate: formatDate,
		generateBlob: generateBlob,
		getHousemaidAssign: getHousemaidAssign,
		getRoute: getRoute,
		getUser: getUser,
		getToken: getToken,
		removeHousemaidAssign: removeHousemaidAssign,
		removeUserData: removeUserData,
		saveHousemaidAssign: saveHousemaidAssign,
		showDownloadDialog: showDownloadDialog
	}
};

/* harmony default export */ __webpack_exports__["a"] = (helper);

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(554)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06c1ea74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(733),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(752),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(732),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(737),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(726),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(758),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b47556ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(725),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-013ee0ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(736),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(756),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ee66636",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38442050",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(743),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(568)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(754),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-849f8920",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(735),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(724),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(560)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(741),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b2c6d75",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(731),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(753),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(748),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(757),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(730),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1006c447",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(755),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-883d9598",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(744),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(728),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(760),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(750),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3 body-border-right",
    attrs: {
      "md5": ""
    }
  }, [_c('filter-list', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.filterValue
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  }), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-search": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "go-to-settings-page": "/",
      "include-delete-single": true,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_c('button', {
          staticClass: "button-transparent",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.showRooms(props.row.rooms, props.row.name, props.row.quantity)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('button', {
          staticClass: "button-transparent",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.showRooms(props.row.rooms, props.row.name, props.row.quantity)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(props.row.quantity) + "\n\t\t\t\t\t\t")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-3",
    attrs: {
      "md7": ""
    }
  }, [_c('v-layout', {
    staticClass: "body-border-bottom",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mb-3",
    attrs: {
      "md6": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": 'Habitación'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-start": ""
    }
  }, [(_vm.roomsQuantity) ? _c('h3', {
    staticClass: "semibold-blue-title-20"
  }, [_vm._v(_vm._s(_vm.roomTypeName) + " - " + _vm._s(_vm.roomsQuantity))]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-start": ""
    }
  }, _vm._l((_vm.rooms), function(room) {
    return _c('room-number-list', {
      key: room.id,
      attrs: {
        "link": ("/rooms/" + (room.id)),
        "room": room
      }
    })
  }))], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('v-layout', {
    staticClass: "align-items-center login-body-container",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticClass: "login-body"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('img', {
    staticClass: "app-logo",
    attrs: {
      "src": "/static/img/logo-clerkinn-use.png",
      "alt": "logo-clerkinn"
    }
  })]), _vm._v(" "), _c('v-form', {
    staticClass: "form-body",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": 'Correo electrónico',
      "single-line": "",
      "rules": _vm.emailRules,
      "prepend-icon": "mail_outline",
      "append-icon": _vm.validateEmail(_vm.model.email) ? 'check' : '',
      "append-icon-cb": function () { return (_vm.model.email = !_vm.model.email); },
      "required": ""
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.model.email = $$v
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": 'Contraseña',
      "single-line": "",
      "rules": _vm.passwordRules,
      "prepend-icon": "vpn_key",
      "append-icon": _vm.model.password ? 'check' : '',
      "append-icon-cb": function () { return (_vm.model.password = !_vm.model.password); },
      "type": 'password',
      "required": ""
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.model.password = $$v
      },
      expression: "model.password"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "remember-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-flex-end": "",
      "align-items-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "label-check",
    attrs: {
      "xs11": "",
      "text-xs-right": ""
    }
  }, [_vm._v("Recordar mis datos")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "success",
      "append-icon": _vm.rememberLogin ? 'check_circle' : 'radio_button_unchecked',
      "append-icon-cb": function () { return (_vm.rememberLogin = !_vm.rememberLogin); },
      "hide-details": ""
    },
    model: {
      value: (_vm.rememberLogin),
      callback: function($$v) {
        _vm.rememberLogin = $$v
      },
      expression: "rememberLogin"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "button-login",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading,
      "loading": _vm.loading
    }
  }, [_vm._v("\n\t\t\t\t\t\tIngresar\n\t\t\t\t\t")])], 1)], 1)], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "align-items-center login-footer",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Privacidad")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Términos y condiciones")])], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pr-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.languages,
      "box": true,
      "hide-details": ""
    },
    model: {
      value: (_vm.currentLanguage),
      callback: function($$v) {
        _vm.currentLanguage = $$v
      },
      expression: "currentLanguage"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-housekeeping"
  }, [_c('v-tabs', {
    attrs: {
      "dark": "",
      "scrollable": false,
      "grow": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "to": tab.link,
        "exact": ""
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t")])
  }), _vm._v(" "), _c('v-tabs-slider', {
    staticClass: "default-dark"
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-container"
  }, [_c('calendar-header', {
    attrs: {
      "month": _vm.month,
      "year": _vm.year
    },
    on: {
      "change-month": _vm.changeMonth
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "day-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return _c('div', {
      key: day.id,
      staticClass: "day-item",
      class: {
        'inactive': day.disabled
      }
    }, [_c('p', {
      staticClass: "number"
    }, [_vm._v(_vm._s(day.day))]), _vm._v(" "), _c('p', {
      staticClass: "day-text"
    }, [_vm._v(_vm._s(day.dayName))])])
  })], 2), _vm._v(" "), _vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "day-container"
    }, [_c('div', {
      staticClass: "room-item"
    }, [_c('span', [_vm._v(_vm._s(room.number))])]), _vm._v(" "), _c('div', {
      staticClass: "room-item"
    }, [_c('span', [_vm._v(_vm._s(room.type))])]), _vm._v(" "), _vm._l((room.maids), function(maid) {
      return (!maid.color) ? _c('div', {
        key: maid.id,
        staticClass: "day-item"
      }, [_c('avatar-profile', {
        staticClass: "avatar-margin",
        attrs: {
          "id": maid.id,
          "firstname": maid.firstname,
          "type-cleaning": maid.typeCleaning,
          "time": maid.time,
          "lastname": maid.lastname,
          "color": maid.color
        }
      })], 1) : _c('div', {
        staticClass: "day-item",
        class: {
          'new': !maid.disabled
        }
      }, [(!maid.disabled) ? _c('div', {
        staticClass: "new-icon"
      }, [_c('button', {
        staticClass: "btn-add-day",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.onDayClick(maid, room)
          }
        }
      }, [_vm._v("+")])]) : _vm._e()])
    })], 2)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room-item"
  }, [_c('span', [_vm._v("Nº")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room-item"
  }, [_c('span', [_vm._v("Hab.")])])
}]}

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user-selector-list"
  }, _vm._l((_vm.users), function(user) {
    return _c('user-selector', {
      key: user.id,
      attrs: {
        "user": user
      },
      on: {
        "radio-on-change": _vm.changeSelected
      }
    })
  }))
},staticRenderFns: []}

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notfound"
  })
},staticRenderFns: []}

/***/ }),

/***/ 737:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("chip-status status-" + _vm.cleanState + " " + _vm.size),
    style: (_vm.styleRoom)
  }, [(_vm.extraState) ? _c('span', {
    class: ("extra-state sprite-states " + _vm.extraState)
  }) : _vm._e(), _vm._v(" "), (_vm.isAdded && !_vm.room.isSelected) ? _c('button', {
    staticClass: "is-added",
    on: {
      "click": function($event) {
        _vm.removeOfList(_vm.roomId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.isSelected),
      expression: "room.isSelected"
    }],
    attrs: {
      "type": "checkbox",
      "hidden": "",
      "disabled": _vm.isAdded,
      "name": "rooms",
      "id": _vm.labelFor
    },
    domProps: {
      "checked": Array.isArray(_vm.room.isSelected) ? _vm._i(_vm.room.isSelected, null) > -1 : (_vm.room.isSelected)
    },
    on: {
      "change": function($event) {
        _vm.onChange(_vm.room)
      },
      "__c": function($event) {
        var $$a = _vm.room.isSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.room.isSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.room.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.room.isSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disabled': _vm.isAdded, 'label-with-circle': _vm.showCircle
    },
    style: (("background-color: " + _vm.backgroundColor)),
    attrs: {
      "for": _vm.labelFor
    }
  }, [(_vm.showCircle) ? _c('div', {
    staticClass: "check-circle-container"
  }, [_c('span', {
    staticClass: "check-circle",
    class: {
      'close': _vm.isAdded
    }
  }, [(_vm.isAdded) ? _c('v-btn', {
    staticClass: "remove-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.removeOfList(_vm.roomId)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isAdded && _vm.room.isSelected) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.name) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.name))])]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.number))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.code))]), _vm._v(" "), (_vm.showCircle && _vm.isAdded) ? _c('span', {
    staticClass: "name-state"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.stateCode) + "\n\t\t\t")]) : _vm._e()]), _vm._v(" "), (_vm.statusIcon) ? _c('div', {
    staticClass: "chip-icon",
    class: {
      'top-status': _vm.nameState
    }
  }, [_c('span', {
    class: ("sprite-states " + _vm.statusIcon)
  })]) : (_vm.statusIconImg) ? _c('div', {
    staticClass: "chip-icon",
    class: {
      'top-status': _vm.nameState
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.statusIconImg,
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.nameState) ? _c('div', {
    staticClass: "name-label"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.nameState) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-container",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('span', [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "maid-profile"
  }, [_c('img', {
    staticClass: "maid-image",
    attrs: {
      "src": "http://placecage.com/gif/25/25",
      "alt": "Maria Chiappe",
      "width": "24",
      "height": "24"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "maid-name"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "maid-clean"
  }, [_c('span', {
    staticClass: "description-text"
  }, [_vm._v("Tipo de Limpieza:")]), _vm._v(" "), _c('span', {
    staticClass: "value-text"
  }, [_vm._v(_vm._s(_vm.typeCleaning))])]), _vm._v(" "), _c('div', {
    staticClass: "maid-actions"
  }, [_c('span', {
    staticClass: "description-text"
  }, [_vm._v("Hora: ")]), _vm._v(" "), _c('span', {
    staticClass: "value-text"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('button', {
    staticClass: "btn-maid",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.actionButton
    }
  }, [_vm._v("Editar")])])])
},staticRenderFns: []}

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "filter-list"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'active': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.selectFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t" + _vm._s(filter.label) + "\n\t")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "planning"
  }, [_c('calendar', {
    attrs: {
      "rooms": _vm.rooms,
      "month": _vm.month,
      "year": _vm.year,
      "days": _vm.days
    },
    on: {
      "change-month": _vm.changeMonth,
      "on-add-day": _vm.openModal
    }
  }), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "height": "584px"
    },
    attrs: {
      "width": "714",
      "scrollable": ""
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('v-card', {
    staticClass: "px-4 modal-maid"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.openModal
    }
  }, [_c('v-icon', {
    staticClass: "icon-close",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Asignar Mucama")]), _vm._v(" "), _c('div', {
    staticClass: "maid-list"
  }, [_c('user-selector-list', {
    attrs: {
      "users": _vm.maids
    },
    on: {
      "on-change-selected": _vm.onMaidSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clean-container"
  }, [_c('div', {
    staticClass: "clean-type"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Tipo de Limpieza:")]), _vm._v(" "), _c('div', {
    staticClass: "clean-types-list"
  }, _vm._l((_vm.cleanTypes), function(item) {
    return _c('div', {
      key: item.id
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.model.cleanTypeSelected),
        expression: "model.cleanTypeSelected"
      }],
      staticClass: "input-clean-type",
      attrs: {
        "type": "radio",
        "hidden": "",
        "name": "cleanTypes",
        "id": item.id
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.model.cleanTypeSelected, item.id)
      },
      on: {
        "__c": function($event) {
          _vm.model.cleanTypeSelected = item.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "clean-type",
      attrs: {
        "for": item.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "body-border-left ml-4 mr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "clean-time"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Hora:")]), _vm._v(" "), _c('div', {
    staticClass: "clean-form"
  }, [_c('div', [_c('span', {
    staticClass: "container-icon-description time-done"
  }, [_c('span', {
    staticClass: "sprite-icons time-done"
  })])]), _vm._v(" "), _c('div', [_c('v-select', {
    staticClass: "time-select",
    attrs: {
      "items": _vm.hours,
      "hide-details": ""
    },
    model: {
      value: (_vm.model.hour),
      callback: function($$v) {
        _vm.model.hour = $$v
      },
      expression: "model.hour"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-select', {
    staticClass: "time-select",
    attrs: {
      "items": _vm.minutes,
      "hide-details": ""
    },
    model: {
      value: (_vm.model.minute),
      callback: function($$v) {
        _vm.model.minute = $$v
      },
      expression: "model.minute"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clean-types-list"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.modeClock),
      expression: "model.modeClock"
    }],
    staticClass: "input-clean-type",
    attrs: {
      "type": "radio",
      "hidden": "",
      "name": "tymeClean",
      "id": "am",
      "value": "am"
    },
    domProps: {
      "checked": _vm._q(_vm.model.modeClock, "am")
    },
    on: {
      "__c": function($event) {
        _vm.model.modeClock = "am"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "clean-type",
    staticStyle: {
      "max-width": "64px"
    },
    attrs: {
      "for": "am"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t.a.m.\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.modeClock),
      expression: "model.modeClock"
    }],
    staticClass: "input-clean-type",
    attrs: {
      "type": "radio",
      "hidden": "",
      "name": "tymeClean",
      "id": "pm",
      "value": "pm"
    },
    domProps: {
      "checked": _vm._q(_vm.model.modeClock, "pm")
    },
    on: {
      "__c": function($event) {
        _vm.model.modeClock = "pm"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "clean-type",
    staticStyle: {
      "max-width": "64px"
    },
    attrs: {
      "for": "pm"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t.p.m.\n\t\t\t\t\t\t\t\t")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clean-comment mt-2"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Comentario o Sugerencia")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.comment),
      expression: "model.comment"
    }],
    staticClass: "comment mt-2",
    attrs: {
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.model.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.comment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "assign-btn white--text",
    attrs: {
      "disabled": _vm.isValid,
      "loading": _vm.isLoading,
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.assignMaid($event)
      }
    }
  }, [_vm._v("Asignar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('v-app', {
    class: {
      'login-select': _vm.$route.name === 'login'
    }
  }, [_c('router-view', {
    attrs: {
      "name": "login"
    }
  }), _vm._v(" "), (_vm.$route.name !== 'login') ? _c('div', [(_vm.showProgress) ? _c('v-progress-linear', {
    staticClass: "progress-linear--global",
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "right": true,
      "success": _vm.snackbar.success,
      "info": _vm.snackbar.info,
      "warning": _vm.snackbar.warning,
      "error": _vm.snackbar.error,
      "primary": _vm.snackbar.primary,
      "secondary": _vm.snackbar.secondary
    },
    model: {
      value: (_vm.snackbar.visible),
      callback: function($$v) {
        _vm.snackbar.visible = $$v
      },
      expression: "snackbar.visible"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.snackbar.message) + "\n\t\t\t\t"), _c('v-btn', {
    staticClass: "dark--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleSnackBar($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 743:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-container"
  }, [(_vm.user.isAdded) ? _c('button', {
    staticClass: "is-added",
    on: {
      "click": _vm.removeOfList
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "hidden": "",
      "id": ("user-" + (_vm.user.id)),
      "name": "user-selector",
      "type": "radio",
      "disabled": _vm.user.isOnlyRead
    },
    domProps: {
      "value": _vm.user
    },
    on: {
      "change": function($event) {
        _vm.radioOnChange(_vm.user)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "user-selector",
    class: {
      'disabled': _vm.user.isOnlyRead
    },
    attrs: {
      "for": ("user-" + (_vm.user.id))
    }
  }, [_c('span', {
    staticClass: "user-avatar"
  }, [_c('img', {
    attrs: {
      "alt": _vm.user.name,
      "src": _vm.user.url_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-data"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.name) + " " + _vm._s(_vm.user.lastname))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.user.quantity_rooms) ? _c('span', {
    staticClass: "user-assignments"
  }, [_vm._v(_vm._s(_vm.user.quantity_rooms) + " mucamas")]) : _vm._e(), _vm._v(" "), (_vm.user.room_assigned >= 0) ? _c('span', {
    staticClass: "user-assignments"
  }, [_vm._v(_vm._s(_vm.user.room_assigned) + " habitaciones")]) : _vm._e()])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "inline-paragraph"
  }, [_vm._v("\n\t" + _vm._s(_vm.documentName) + ":\n")])
},staticRenderFns: []}

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "room-number-list"
  }, [(_vm.tag === 'label' && !_vm.editIsActive) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.isSelected),
      expression: "room.isSelected"
    }],
    attrs: {
      "name": "rooms",
      "hidden": "",
      "type": "checkbox",
      "disabled": _vm.room.isAssigned,
      "id": _vm.labelFor
    },
    domProps: {
      "checked": Array.isArray(_vm.room.isSelected) ? _vm._i(_vm.room.isSelected, null) > -1 : (_vm.room.isSelected)
    },
    on: {
      "change": function($event) {
        _vm.roomSelected(_vm.room, _vm.index)
      },
      "__c": function($event) {
        var $$a = _vm.room.isSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.room.isSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.room.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.room.isSelected = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editIsActive) ? _c('div', {
    staticClass: "edit-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.codeRoom),
      expression: "room.codeRoom"
    }],
    staticClass: "input-to-edit",
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.room.codeRoom)
    },
    on: {
      "click": _vm.clickEdit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.room.codeRoom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "delete-icon",
    on: {
      "click": function($event) {
        _vm.onRoomRemove(_vm.room)
      }
    }
  }, [_vm._v("cancel")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editIsActive) ? _c('label', {
    staticClass: "room-number",
    class: {
      'disabled': _vm.room.isAssigned, 'active': _vm.room.isSelected
    },
    attrs: {
      "for": _vm.labelFor
    },
    on: {
      "click": function($event) {
        _vm.goToLink(_vm.link)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.room.codeRoom))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "button-create-container"
  }, [(_vm.btnFunction) ? _c('button', {
    staticClass: "button-create",
    staticStyle: {
      "justify-content": "center !important"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.functionClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(" " + _vm._s(_vm.text))])]) : _c('button', {
    staticClass: "button-create"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.href
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.text))])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.$route.name === 'dashboard-sales') ? _c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-select', {
    staticClass: "sucursal-select",
    attrs: {
      "items": _vm.items,
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "building-select",
    attrs: {
      "items": _vm.buildings,
      "label": "Edificio",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e2),
      callback: function($$v) {
        _vm.e2 = $$v
      },
      expression: "e2"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "rooms-select",
    attrs: {
      "items": _vm.rooms,
      "label": "Todas las habitaciones",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e3),
      callback: function($$v) {
        _vm.e3 = $$v
      },
      expression: "e3"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('v-select', {
    staticClass: "start-date-select",
    attrs: {
      "items": _vm.startDate,
      "label": "16 de octubre, 2016",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e4),
      callback: function($$v) {
        _vm.e4 = $$v
      },
      expression: "e4"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "finish-date-select",
    attrs: {
      "items": _vm.finishDate,
      "label": "10 de noviembre, 2016",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e5),
      callback: function($$v) {
        _vm.e5 = $$v
      },
      expression: "e5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "offset-md2": ""
    }
  }, [_c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Año")]), _vm._v(" "), _c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Mes")]), _vm._v(" "), _c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Semana")]), _vm._v(" "), _c('button', {
    staticClass: "button-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Día")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "divider-rows",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "divider1",
    attrs: {
      "md6": ""
    }
  }, [_c('v-layout', {
    staticClass: "room-filters",
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Habitaciones")]), _vm._v(" "), _c('v-select', {
    staticClass: "general-select",
    attrs: {
      "items": _vm.general,
      "label": "General",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e6),
      callback: function($$v) {
        _vm.e6 = $$v
      },
      expression: "e6"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "status-select",
    attrs: {
      "items": _vm.statusType,
      "label": "Tipos de estado",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.e7),
      callback: function($$v) {
        _vm.e7 = $$v
      },
      expression: "e7"
    }
  }), _vm._v(" "), _c('button', [_vm._v("Editar")])], 1), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('v-layout', {
      key: state.id,
      staticClass: "text-xs-left",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md12": ""
      }
    }, [_c('div', {
      staticClass: "label-status"
    }, [_c('h5', [_vm._v(_vm._s(state.name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(state.rooms.length) + " habitaciones")])])])], 1)
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider2",
    attrs: {
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Estados")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "big",
    attrs: {
      "row": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "big-yellow"
  }, [_c('p', [_vm._v("15")])]), _vm._v(" "), _c('label', [_vm._v("En turno de baño o break")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-red"
  }, [_c('p', [_vm._v("03")])]), _vm._v(" "), _c('label', [_vm._v("Bajo rendimiento")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-green"
  }, [_c('p', [_vm._v("05")])]), _vm._v(" "), _c('label', [_vm._v("Alto rendimiento")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Mucamas")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "label-status mb-0"
  }, [_c('h5', [_vm._v("Nombre")]), _vm._v(" "), _c('h5', [_vm._v("Habitación")]), _vm._v(" "), _c('h5', [_vm._v("Calificación")])])]), _vm._v(" "), _vm._l((_vm.maidsNames), function(maid) {
    return _c('v-layout', {
      key: maid.id,
      staticClass: "report-maid",
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('h5', [_vm._v(_vm._s(maid.name))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('div', {
      class: ("score-ball-" + (maid.qualification))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('h5', [_vm._v(_vm._s(maid.room))])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "alerts",
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Alertas")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "big b-alerts",
    attrs: {
      "row": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "big-skyblue"
  }, [_c('p', [_vm._v("16")])]), _vm._v(" "), _c('label', [_vm._v("Objetos perdidos")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-red"
  }, [_c('p', [_vm._v("13")])]), _vm._v(" "), _c('label', [_vm._v("Reportar problemas")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "big-yellow"
  }, [_c('p', [_vm._v("11")])]), _vm._v(" "), _c('label', [_vm._v("Mantenimiento")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Actividades - Real time")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "realtime-content"
  }, [_c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/59.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Maria Chiappe\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("cambió de estado")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("En curso")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("Almuerzo")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/32.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Almendra Gomez\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("terminó de limpiar la habitación")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("5202")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/men/78.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Giovanni Alvarado\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("cambió de estado")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-red"
  }, [_vm._v("Ocupado sucio")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-green"
  }, [_vm._v("Vacante limpio")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("habitación")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("5202")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/95.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("Fernanda Rivera\n\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("reportó una perdida de la habitación")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("5412")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-red"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar-blue"
  }), _vm._v(" "), _c('h6', [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am")])])], 1)], 1)], 1)], 1)])], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-header-container"
  }, [_c('button', {
    staticClass: "arrow",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeMonth(1)
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('p', {
    staticClass: "calendar-title"
  }, [_vm._v(_vm._s(_vm.dateInformation.monthName) + " " + _vm._s(_vm.year))]), _vm._v(" "), _c('button', {
    staticClass: "arrow",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeMonth(2)
      }
    }
  }, [_vm._v(">")])])
},staticRenderFns: []}

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-container",
    style: (_vm.avatarStyle)
  }, [_c('popup-maid', {
    attrs: {
      "visible": _vm.showPopup,
      "time": _vm.time,
      "type-cleaning": _vm.typeCleaning,
      "name": (_vm.firstname + " " + _vm.lastname)
    },
    on: {
      "close-popup": _vm.actionAvatar,
      "action-popup": _vm.editMaid
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-text",
    on: {
      "click": _vm.actionAvatar
    }
  }, [_vm._v(_vm._s(_vm.avatarLetters))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "print-no-show",
    attrs: {
      "persistent": "",
      "overflow": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "toolbar--hk",
    attrs: {
      "flat": ""
    }
  }, [_c('img', {
    staticClass: "mx-a",
    attrs: {
      "src": "/static/img/logo-control-inn.png"
    }
  })]), _vm._v(" "), _c('v-list', {
    staticClass: "py-0 list--hk",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.sidebar), function(item, i) {
    return [_c('v-list-group', {
      key: i,
      attrs: {
        "no-action": ""
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          item.active = $$v
        },
        expression: "item.active"
      }
    }, [(item.resource.data.length > 0) ? _c('v-list-tile', {
      slot: "item"
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "src": item.pathIcon,
        "alt": item.name,
        "width": "19",
        "height": "19"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])], 1)], 1) : _c('v-list-tile', {
      key: i,
      class: {
        'active': ("/" + (_vm.$route.fullPath.split('/')[1])) === item.url
      },
      attrs: {
        "to": item.url
      },
      slot: "item"
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "src": item.iconUrl,
        "alt": item.description,
        "width": "17",
        "height": "17"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _vm._l((item.resource.data), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        staticClass: "sidebar-bg",
        class: {
          'active': ("/" + (_vm.$route.fullPath.split('/')[1])) === child.uri
        },
        attrs: {
          "to": {
            name: ("" + (child.uri))
          }
        }
      }, [(child.iconUrl) ? _c('v-list-tile-action', [_c('img', {
        attrs: {
          "src": child.iconUrl,
          "alt": child.description,
          "width": "17",
          "height": "17"
        }
      })]) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(child.name) + "\n\t\t\t\t\t\t\t")])], 1)], 1)
    })], 2)]
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "white toolbar-header toolbar--hk print-no-show",
    attrs: {
      "fixed": "",
      "light": ""
    }
  }, [_c('button', {
    staticClass: "button-drawer ma-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/bars.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "notifications-btn mr-3",
    attrs: {
      "type": "button",
      "id": "buttonNotifications"
    },
    on: {
      "click": _vm.openNotifications
    }
  }, [_c('p', {
    class: {
      'animated bounceIn': _vm.newNotification
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.notificationsQuantity))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//picture-controlinn.s3.amazonaws.com/housekeeping/icon-notification.svg",
      "alt": "",
      "height": "22",
      "width": "21"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificationsList),
      expression: "notificationsList"
    }],
    staticClass: "notifications-container",
    attrs: {
      "id": "notifications"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "text-xs-left": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Sucursal:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Cliente")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Cod. Reserva:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Tipo de Hab.:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Fec. de Reserva:")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "notifications-list",
    attrs: {
      "row": "",
      "wrap": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "notifications-list-height",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('v-flex', {
      key: notification.id,
      staticClass: "notifications-list-border",
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.hotelName))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.customer))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.code))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.roomName))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(_vm._f("parseDate")(notification.bookingStart)) + " - " + _vm._s(_vm._f("parseDate")(notification.bookingEnd)))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "notifications-actions",
      attrs: {
        "fab": "",
        "dark": "",
        "small": "",
        "error": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteNotification(notification)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "notifications-actions reservation",
      attrs: {
        "fab": "",
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectData(notification)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tR\n\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/qp-hotels-header.svg",
      "alt": "logo-header-qp"
    }
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "layout-nav user",
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "user-name"
  }, [_c('h6', [_vm._v(_vm._s(_vm.user.fullName))])]), _vm._v(" "), _c('button', {
    staticClass: "user-img my-0",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.url_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-menu', {
    staticClass: "pt-1",
    attrs: {
      "offset-y": "",
      "content-class": "menu-layout"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "sprite-extra settings"
  })]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(language, indexLang) {
    return _c('v-list-tile', {
      key: language.id,
      class: {
        'active': indexLang === _vm.localLanguage
      },
      on: {
        "click": function($event) {
          _vm.setLanguage(indexLang)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": language.img,
        "alt": language.name
      }
    })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(language.name))])], 1)
  }))], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "login-button mr-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("power_settings_new")])], 1)], 1), _vm._v(" "), _c('main', {
    staticClass: "print-width"
  }, [
    [_c('div', {
      class: {
        'billing-breadcrumb-style': _vm.$route.path === '/billing/list'
      }
    }, [(_vm.$route.path === '/billing/list') ? _c('div', {
      staticClass: "billing-breadcrumb"
    }, [_c('div', {
      staticClass: "billing-resume"
    }, [_c('div', [_c('p', {
      staticClass: "billing-resume-title"
    }, [_vm._v("INGRESOS")]), _vm._v(" "), _c('p', {
      staticClass: "billing-resume-content"
    }, [_vm._v("$" + _vm._s(_vm._f("round")(_vm.bookingsAmountTotal)))])]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "billing-resume-title"
    }, [_vm._v("Ocupación Actual")]), _vm._v(" "), _c('p', {
      staticClass: "billing-resume-content"
    }, [_vm._v(_vm._s(_vm.bookingsTotal))])])]), _vm._v(" "), _c('div', {
      staticClass: "billing-vertical-spacer"
    }), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select-billing",
      attrs: {
        "placeholder": "qp Lima",
        "selec": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-breadcrumbs', {
      class: {
        'housemaid-breadcrumb': _vm.$route.name.split('-')[0] === 'housemaids' && _vm.$route.name !== 'housemaids-by-state'
      },
      attrs: {
        "divider": "»"
      }
    }, _vm._l((_vm.$breadcrumbsItems), function(item, itemIndex) {
      return _c('v-breadcrumbs-item', {
        key: itemIndex,
        attrs: {
          "to": item.href,
          "disabled": item.disabled,
          "active-class": 'breadcrumbs__item--active'
        }
      }, [(_vm.firstItem(itemIndex)) ? _c('img', {
        class: {
          'breadcrumb-company-icon': item.href === '/company'
        },
        attrs: {
          "src": (_vm.$imageS3 + "/clerkinn/breadcrumbs/" + (item.id) + "." + (item.extension))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-1"
      }, [_vm._v(_vm._s(item.text))])])
    }))], 1), _vm._v(" "), (_vm.$route.path === '/billing/list') ? _c('hr', {
      staticClass: "billing-spacer"
    }) : _vm._e()], _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": "",
        "fluid": ""
      }
    }, [_c('router-view')], 1)
  ], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300",
      "content-class": "modal-logout"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("¿Está seguro de que desea salir?")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "btn-save mb-2 mr-2",
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-cancel mb-2",
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_vm._v("Salir")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[389]);


// WEBPACK FOOTER //
// static/js/app.08b4df7496e6e4323d2c.js